import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import LineString from '../geom/LineString';
import HashMap from '../../../../java/util/HashMap';
import GeometryTransformer from '../geom/util/GeometryTransformer';
import TaggedLinesSimplifier from './TaggedLinesSimplifier';
import IllegalArgumentException from '../../../../java/lang/IllegalArgumentException';
import GeometryComponentFilter from '../geom/GeometryComponentFilter';
import TaggedLineString from './TaggedLineString';
var TopologyPreservingSimplifier = /*#__PURE__*/function () {
  function TopologyPreservingSimplifier() {
    _classCallCheck(this, TopologyPreservingSimplifier);
    TopologyPreservingSimplifier.constructor_.apply(this, arguments);
  }
  _createClass(TopologyPreservingSimplifier, [{
    key: "getResultGeometry",
    value: function getResultGeometry() {
      if (this._inputGeom.isEmpty()) return this._inputGeom.copy();
      this._linestringMap = new HashMap();
      this._inputGeom.apply(new LineStringMapBuilderFilter(this));
      this._lineSimplifier.simplify(this._linestringMap.values());
      var result = new LineStringTransformer(this._linestringMap).transform(this._inputGeom);
      return result;
    }
  }, {
    key: "setDistanceTolerance",
    value: function setDistanceTolerance(distanceTolerance) {
      if (distanceTolerance < 0.0) throw new IllegalArgumentException('Tolerance must be non-negative');
      this._lineSimplifier.setDistanceTolerance(distanceTolerance);
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._inputGeom = null;
      this._lineSimplifier = new TaggedLinesSimplifier();
      this._linestringMap = null;
      var inputGeom = arguments[0];
      this._inputGeom = inputGeom;
    }
  }, {
    key: "simplify",
    value: function simplify(geom, distanceTolerance) {
      var tss = new TopologyPreservingSimplifier(geom);
      tss.setDistanceTolerance(distanceTolerance);
      return tss.getResultGeometry();
    }
  }]);
  return TopologyPreservingSimplifier;
}();
export { TopologyPreservingSimplifier as default };
var LineStringTransformer = /*#__PURE__*/function (_GeometryTransformer) {
  _inherits(LineStringTransformer, _GeometryTransformer);
  function LineStringTransformer() {
    var _this;
    _classCallCheck(this, LineStringTransformer);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(LineStringTransformer).call(this));
    LineStringTransformer.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(LineStringTransformer, [{
    key: "transformCoordinates",
    value: function transformCoordinates(coords, parent) {
      if (coords.size() === 0) return null;
      if (parent instanceof LineString) {
        var taggedLine = this._linestringMap.get(parent);
        return this.createCoordinateSequence(taggedLine.getResultCoordinates());
      }
      return _get(_getPrototypeOf(LineStringTransformer.prototype), "transformCoordinates", this).call(this, coords, parent);
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._linestringMap = null;
      var linestringMap = arguments[0];
      this._linestringMap = linestringMap;
    }
  }]);
  return LineStringTransformer;
}(GeometryTransformer);
var LineStringMapBuilderFilter = /*#__PURE__*/function () {
  function LineStringMapBuilderFilter() {
    _classCallCheck(this, LineStringMapBuilderFilter);
    LineStringMapBuilderFilter.constructor_.apply(this, arguments);
  }
  _createClass(LineStringMapBuilderFilter, [{
    key: "filter",
    value: function filter(geom) {
      if (geom instanceof LineString) {
        var line = geom;
        if (line.isEmpty()) return null;
        var minSize = line.isClosed() ? 4 : 2;
        var taggedLine = new TaggedLineString(line, minSize);
        this.tps._linestringMap.put(line, taggedLine);
      }
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [GeometryComponentFilter];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this.tps = null;
      var tps = arguments[0];
      this.tps = tps;
    }
  }]);
  return LineStringMapBuilderFilter;
}();
TopologyPreservingSimplifier.LineStringTransformer = LineStringTransformer;
TopologyPreservingSimplifier.LineStringMapBuilderFilter = LineStringMapBuilderFilter;